import React from "react";

const Footer: React.FC = () => {

    return (
        <div style={{textAlign: 'center', padding: '1rem', fontSize:'0.8rem', color:'#585858'}}>
            <div>Albemarle VMS ©{new Date().getFullYear()} &nbsp;  v1.3.27.20250709</div>
            <div><a style={{ color:'#585858'}} href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2025144113号-1</a></div>
        </div>
    )
}

export default Footer;